import type { ReactNode } from 'react';

interface StatCardProps {
  label: string;
  value: ReactNode;
  caption?: string;
  icon?: ReactNode;
}

/**
 * Dashboard stat card: mono uppercase eyebrow label with a leading rule,
 * a large numeral, a muted caption, and an optional icon top-right.
 */
export function StatCard({ label, value, caption, icon }: StatCardProps) {
  return (
    <article className="rfp-stat-card">
      <div className="rfp-stat-card__top">
        <span className="rfp-stat-card__label">
          <span aria-hidden="true" className="rfp-stat-card__rule" />
          {label}
        </span>
        {icon && (
          <span aria-hidden="true" className="rfp-stat-card__icon">
            {icon}
          </span>
        )}
      </div>
      <p className="rfp-stat-card__value">{value}</p>
      {caption && <p className="rfp-stat-card__caption">{caption}</p>}
    </article>
  );
}
